import { render, staticRenderFns } from "./Terms1.vue?vue&type=template&id=914463d2&"
import script from "./Terms1.vue?vue&type=script&lang=js&"
export * from "./Terms1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports